module.exports = "../static/media/SweetDrama.43cd4076.svg";